class Locale
{
    constructor() {
        this._setLocaleIfDoesntExist();

        let locale = JSON.parse(localStorage.getItem("_locale"));
        this._language = locale.language;
        this._region = locale.region;
    }

    /**
     * Set the default locale if it doesn't exist.
     * 
     * @return {void}
     */
    _setLocaleIfDoesntExist()
    {
        if(!this._exists()) {
            this._language = "en";
            this._region = null;
            this.save();
        }
    }

    /**
     * Check if the locale exists.
     * 
     * @return {Boolean}
     */
    _exists()
    {
        let locale = localStorage.getItem("_locale");
        return locale !== null && locale !== undefined && locale.trim() !== "";
    }

    /**
     * Update the locale by saving to the locale storage.
     */
    save()
    {
        let locale = {
            language: this._language,
            region: this._region
        }
        localStorage.setItem("_locale", JSON.stringify(locale));
    }

    /**
     * Set the language.
     * 
     * @param {String} language
     * 
     * @return {Locale}
     */
    setLanguage(language)
    {
        this._language = language;
        return this;
    }

    /**
     * Get the language.
     * 
     * @return {String}
     */
    getLanguage()
    {
        return this._language;
    }

    /**
     * Set the region.
     * 
     * @param {String} region
     * 
     * @return {Locale}
     */
    setRegion(region)
    {
        this._region = region;
        return this;
    }

    /**
     * Get the region.
     * 
     * @return {String}
     */
    getRegion()
    {
        return this._region;
    }

    /**
     * Get the translation given the key and the source object.
     * If the language parameter is set to null, language 
     * is detected from the locale storage.
     * 
     * @param {String} keyToTranslate
     * @param {Stirng} sourceObject
     * @param {String} language
     * 
     * @return {String|null}
     */
    static _translate(keyToTranslate, sourceObject, language = null)
    {
        if(language == null) {
            let locale = new Locale;
            language = locale.getLanguage();
        }

        language = language.charAt(0).toUpperCase() + language.slice(1);

        let keyWithLanguage = keyToTranslate + language;
        if(Locale._translationExists(keyWithLanguage, sourceObject))
            return sourceObject[keyWithLanguage];

        keyWithLanguage = keyToTranslate + language.toUpperCase();
        if(Locale._translationExists(keyWithLanguage, sourceObject))
            return sourceObject[keyWithLanguage];
        
        return sourceObject[keyToTranslate];
    }

    /**
     * Check if translation exists.
     * 
     * @param {String} key
     * @param {String} sourceObject
     * 
     * @return {Boolean}
     */
    static _translationExists(key, sourceObject) 
    {
        return sourceObject[key] !== null && sourceObject[key] !== undefined && sourceObject[key].trim() != "" ? true : false;
    }

}

export default Locale;